"use strict";

function changeActiveLawyer(item, target) {
  // console.log(li);
  var $underline = $('.js-underline');
  item.each(function () {
    if ($(this).hasClass('current')) {
      $underline.css({
        'left': $(this).offset().left,
        'width': $(this).width(),
        'opacity': '1'
      });
    }
  });
}

(function ($) {
  var offsets = [];

  var setSize = function setSize(that) {
    offsets = [];
    that.each(function () {
      var target = $(this).data('scroll-to'),
          offset = $('.js-section-nav').length ? $('.js-section-nav').height() : 0,
          block = $(this).data('scroll-active');
      offsets.push({
        trigger: $(this),
        offset: offset,
        top: $(target).offset().top,
        height: $(block).outerHeight()
      });
    });
  };

  $.fn.scrollActiveGesica = function () {
    var that = this;
    setSize(that);
    $window.on('resize', function () {
      setSize(that);
    });
    $window.on('scroll', function () {
      var scrollTop = $(this).scrollTop();
      var selected = null;
      offsets.map(function (elem, i) {
        var topLast = Math.abs(scrollTop - elem.top),
            topFirst = Math.floor(elem.top);

        if ($(window).width() > 899) {
          topLast = topLast - elem.offset;
          topFirst = topFirst - elem.offset;

          if ($('.js-search').length) {
            topLast = topLast - $('.js-search').height();
            topFirst = topFirst - $('.js-search').height();
          }
        }

        if (topFirst <= scrollTop && topLast <= elem.height) {
          selected = elem.trigger;
        }
      }); // console.log(selected);

      if (selected && !selected.hasClass('current')) {
        that.parent().removeClass('current');
        selected.parent().addClass('current');
      }

      if (!selected) {
        that.parent().removeClass('current');
      } // console.log(scrollTop);

    });
  };
})(jQuery);

$(function () {
  if ($('.js-scroll-to.lawyer-firm').length) {
    $('.js-scroll-to.lawyer-firm').scrollActiveGesica();
  }
});